import { DefaultTheme } from 'styled-components';

import { theme as colorTheme, resolvedTypography, typography } from './design-tokens';

// Everything that is not a color token. Tests build their theme from this plus the
// resolved light colors (testTheme in test-utils), because jsdom cannot resolve var().
export const nonColorTheme = {
  fontSizes: {
    xxs: '11px',
    xs: '12px',
    sm: '14px',
    // base is Paragraph/Large and 2xl is Display 2, both read from the generated typography with
    // their line heights below, so a pair cannot drift apart (src/__tests__/theme-sourcing.test.ts).
    base: resolvedTypography.paragraphLarge.fontSize,
    lg: '24px',
    xl: '32px',
    '1xl': '48px',
    '2xl': resolvedTypography.display2.fontSize,
  },
  // Two keys map to one Figma line height and are read from the generated typography, so a Figma
  // change reaches them: base is the 16px body style (Paragraph/Large), 2xl is Display 2. The other
  // values predate the Figma scale (src/styles/__tests__/typography.test.tsx, "theme scale").
  lineHeights: {
    xxs: '14px',
    xs: '14px',
    sm: '16px',
    base: resolvedTypography.paragraphLarge.lineHeight,
    lg: '32px',
    xl: '40px',
    '1xl': '52px',
    '2xl': resolvedTypography.display2.lineHeight,
  },
  breakpoints: {
    sm: '640px',
    md: '768px',
    lg: '1024px',
    xl: '1280px',
    '2xl': '1536px',
    '3xl': '1920px',
  },
  containers: {
    max: '1920px',
  },
};

// Use this config to define the theme for the application
// Avoid hard coding values in the components, use the theme instead
const theme: DefaultTheme = {
  ...colorTheme,
  ...nonColorTheme,
  typography,
};

export default theme;
